import { isClickedOutside } from '@theme/utilities';

class DropdownGroupComponent extends HTMLElement {
  constructor() {
    super();

    this.dropdowns = [];
  }

  connectedCallback() {
    this.dropdowns = this.querySelectorAll('dropdown-component');

    document.addEventListener('click', this.#handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#handleDocumentClick);
  }

  #handleDocumentClick = (event) => {
    const clickedInsideDropdown = event.target.closest('dropdown-component');
    if (!clickedInsideDropdown) {
      this.closeAllDropdowns();
    }
  };

  closeAllDropdowns() {
    this.dropdowns.forEach((dropdown) => {
      dropdown.close();
    });
  }
}

if (!customElements.get('dropdown-group-component')) {
  customElements.define('dropdown-group-component', DropdownGroupComponent);
}

class DropdownComponent extends HTMLElement {
  constructor() {
    super();

    this.toggle = null;
    this.content = null;
    this.isOpen = false;
  }

  connectedCallback() {
    this.toggle = this.querySelector('[data-ref="dropdown-toggle"]');
    this.content = this.querySelector('[data-ref="dropdown-content"]');

    this.toggle?.addEventListener('click', this.#handleToggle);
    this.addEventListener('focusin', this.#handleFocusIn);
    this.addEventListener('focusout', this.#handleFocusOut);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.#handleToggle);
    this.removeEventListener('focusin', this.#handleFocusIn);
    this.removeEventListener('focusout', this.#handleFocusOut);
    document.removeEventListener('keydown', this.#handleKeydown);
  }

  #handleToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (this.isOpen) {
      this.close();
    } else {
      this.closest('dropdown-group-component')?.closeAllDropdowns();
      this.open();
    }
  };

  #handleClickOutside = (event) => {
    if (isClickedOutside(event, this)) {
      this.close();
    }
  };

  // Ouverture au focus clavier uniquement : :focus-visible écarte le focus
  // donné par un clic ou un appui, que #handleToggle traite déjà.
  #handleFocusIn = (event) => {
    if (this.isOpen) return;
    if (!event.target.matches?.(':focus-visible')) return;

    this.closest('dropdown-group-component')?.closeAllDropdowns();
    this.open();
  };

  #handleFocusOut = (event) => {
    if (this.contains(event.relatedTarget)) return;

    this.close();
  };

  #handleKeydown = (event) => {
    if (event.key !== 'Escape') return;

    this.close();
    this.toggle?.focus();
  };

  open() {
    this.setAttribute('data-open', 'true');
    this.toggle?.setAttribute('aria-expanded', 'true');
    document.addEventListener('click', this.#handleClickOutside);
    document.addEventListener('keydown', this.#handleKeydown);
    this.isOpen = true;
  }

  close() {
    this.setAttribute('data-open', 'false');
    this.toggle?.setAttribute('aria-expanded', 'false');
    document.removeEventListener('click', this.#handleClickOutside);
    document.removeEventListener('keydown', this.#handleKeydown);
    this.isOpen = false;
  }
}

if (!customElements.get('dropdown-component')) {
  customElements.define('dropdown-component', DropdownComponent);
}
